const CALENDAR_DATE = new Intl.DateTimeFormat('es-AR', { timeZone: 'UTC' });

/**
 * Formats a calendar day (contract validity, price validity) as `d/m/yyyy`.
 *
 * The API sends these as UTC midnight. Formatting them in the browser's zone
 * would move every date one day back in Argentina (UTC-3), so the day is read
 * in UTC, where it was written. Do not use this for real instants such as
 * `suspendedAt`; those belong in local time.
 */
export function formatCalendarDate(value: string): string {
  return CALENDAR_DATE.format(new Date(value));
}
